import PropTypes from 'prop-types';
import classNames from 'classnames';

const PdfCardList = ({ className, children }) => (
  <div className={classNames('pdf-card-list', className)}>
    {children}
  </div>
);

PdfCardList.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default PdfCardList;
